export enum PaywallFeature {
  ViewFullsizePhoto = 1,
  OutgoingCommunication = 2,
  NewsfeedSearch = 3,
  ValidateGiftCertificate = 4,
  Blocks = 6,
  BlockingAMember = 7,
  PostsPerHour = 10,
  ChangeOfEmail = 11,
  PhotoStream = 13,
  FeaturedPhotos = 14,
  PhotoUnlockRequests = 15,
  PostsPerDay = 16,
  UploadedPhotos = 17,
  AnonymousViewing = 18,
  UploadedPhotosPerDay = 19,
  MemberSearch = 20,
  MyTypeFilterChange = 21,
}

export interface PaywallErrorResponse {
  error: 'PREMIUM_REQUIRED';
  message: string;
  feature: string;
  resetTime?: string;
}

export function isPaywallError(error: any): error is { status: 403; data: PaywallErrorResponse } {
  return (
    error?.status === 403 &&
    error?.data?.error === 'PREMIUM_REQUIRED' &&
    error?.data?.feature !== undefined
  );
}

/**
 * Converts a PaywallFeature enum value to its string name for API calls.
 */
export function getPaywallFeatureName(feature: PaywallFeature): string {
  return PaywallFeature[feature];
}

/**
 * Converts a feature string name (from API response) to a PaywallFeature enum value.
 */
export function getPaywallFeatureFromString(feature: string): PaywallFeature | undefined {
  const value = PaywallFeature[feature as keyof typeof PaywallFeature];
  return typeof value === 'number' ? value : undefined;
}

